import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";

const projectDetails = {
    0: {
        images: [
            require("../../assets/project0/作品集传网站.jpg"),
            require("../../assets/project0/作品集传网站2.jpg"),
            require("../../assets/project0/作品集传网站3.jpg"),
            require("../../assets/project0/作品集传网站4.jpg"),
            require("../../assets/project0/作品集传网站5.jpg"),
            require("../../assets/project0/作品集传网站6.jpg"),
            require("../../assets/project0/作品集传网站7.jpg"),
            require("../../assets/project0/作品集传网站8.jpg"),
            require("../../assets/project0/作品集传网站9.jpg"),
            require("../../assets/project0/作品集传网站10.jpg"),
            require("../../assets/project0/作品集传网站11.jpg"),
            require("../../assets/project0/作品集传网站12.jpg"),
            require("../../assets/project0/作品集传网站13.jpg"),
            require("../../assets/project0/作品集传网站14.jpg"),

        ],
    },
    1: {
        images: [
            require("../../assets/project1/作品集传网站15.jpg"),
            require("../../assets/project1/作品集传网站16.jpg"),
            require("../../assets/project1/作品集传网站17.jpg"),
            require("../../assets/project1/作品集传网站18.jpg"),
            require("../../assets/project1/作品集传网站19.jpg"),
            require("../../assets/project1/作品集传网站20.jpg"),
        ],
    },
    2: {
        images: [
            require("../../assets/project2/作品集传网站21.jpg"),
            require("../../assets/project2/作品集传网站22.jpg"),
            require("../../assets/project2/作品集传网站23.jpg"),
            require("../../assets/project2/作品集传网站24.jpg"),
            require("../../assets/project2/作品集传网站25.jpg"),
        ],
    },
    3: {
        images: [
            require("../../assets/project3/作品集传网站26.jpg"),
            require("../../assets/project3/作品集传网站27.jpg"),
            require("../../assets/project3/作品集传网站28.jpg"),
            require("../../assets/project3/作品集传网站29.jpg"),
            require("../../assets/project3/作品集传网站30.jpg"),
            require("../../assets/project3/作品集传网站31.jpg"),
            require("../../assets/project3/作品集传网站32.jpg"),
        ],
    },
    4: {
        images: [
            require("../../assets/project4/作品集传网站33.jpg"),
            require("../../assets/project4/作品集传网站34.jpg"),
            require("../../assets/project4/作品集传网站35.jpg"),
            require("../../assets/project4/作品集传网站36.jpg"),
            require("../../assets/project4/作品集传网站37.jpg"),
            require("../../assets/project4/作品集传网站38.jpg"),

        ],
    },
    5: {
        images: [

            require("../../assets/project4/作品集传网站39.jpg"),

        ],
    },
    // Add more projects here...
};

const ProjectDetail = () => {
    const { id } = useParams();
    const project = projectDetails[id];
    const [fixedWidth, setFixedWidth] = useState(null);

    useEffect(() => {
        // 设置固定宽度为初始窗口宽度
        setFixedWidth(window.innerWidth);

        // 可选：如果希望在初始加载后窗口调整不影响固定宽度，可以不添加 resize 监听
        // 如果需要动态更新，可以启用下面的代码，但这会导致缩放时仍然同步变化
        /*
        const updateFixedWidth = () => {
            setFixedWidth(window.innerWidth);
        };

        window.addEventListener('resize', updateFixedWidth);
        return () => window.removeEventListener('resize', updateFixedWidth);
        */
    }, []);

    if (!project) {
        return <div>Project not found</div>;
    }

    return (
        <Container
            fluid
            className="p-0"
            style={{
                width: fixedWidth ? `${fixedWidth}px` : "100%", // 固定宽度为初始窗口宽度
                overflowX: "auto", // 启用水平滚动
                backgroundColor: "#fff",
            }}
        >
            {project.images.map((img, index) => (
                <div
                    key={index}
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        margin: "20px 0", // 图片之间的间距
                    }}
                >
                    <img
                        src={img}
                        alt={`Project ${id} - Image ${index + 1}`}
                        loading="lazy" // 可选：懒加载
                        style={{
                            width: "100%",       // 图片填满容器宽度
                            height: "auto",      // 保持纵横比
                            maxWidth: "none",    // 取消最大宽度限制
                            display: "block",    // 移除底部空白间隙
                        }}
                    />
                </div>
            ))}
        </Container>
    );
};

export default ProjectDetail;
